"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStoreProvider = void 0;
const core_1 = require("@apitable/core");
const redux_batched_actions_1 = require("redux-batched-actions");
class ClientStoreProvider {
    constructor(store) {
        this.store = store;
    }
    createDatasheetStore(dataPack, options) {
        // TODO outdated. Refer to fetchDatasheetPackSuccess for latest code.
        const { isPartOfData, needLoad } = options;
        if (!needLoad) {
            return this.store;
        }
        const dispatchActions = [];
        if (dataPack.foreignDatasheetMap) {
            Object.keys(dataPack.foreignDatasheetMap).forEach(foreignDstId => {
                const foreignDatasheetPack = dataPack.foreignDatasheetMap[foreignDstId];
                dispatchActions.push(core_1.StoreActions.receiveDataPack(foreignDatasheetPack, { isPartOfData: true }));
                if (foreignDatasheetPack.fieldPermissionMap) {
                    dispatchActions.push(core_1.StoreActions.loadFieldPermissionMap(foreignDatasheetPack.fieldPermissionMap, foreignDatasheetPack.datasheet.id));
                }
            });
        }
        if (dataPack.datasheet) {
            dispatchActions.push(core_1.StoreActions.receiveDataPack(dataPack, { isPartOfData, getState: this.store.getState }));
            if (dataPack.units) {
                // init unityMap, for `member` field use
                const unitMap = {};
                dataPack.units.filter(unit => unit.unitId).forEach(unit => (unitMap[unit.unitId] = unit));
                this.store.dispatch(core_1.StoreActions.updateUnitMap(unitMap));
                // init UserMap, for `CreatedBy`/`LastModifiedBy` field use
                const userMap = {};
                dataPack.units.filter(unit => unit.userId).forEach(user => (userMap[user.userId] = user));
                this.store.dispatch(core_1.StoreActions.updateUserMap(userMap));
            }
        }
        if (dataPack.fieldPermissionMap) {
            this.store.dispatch(core_1.StoreActions.loadFieldPermissionMap(dataPack.fieldPermissionMap, dataPack.datasheet.id));
        }
        this.store.dispatch((0, redux_batched_actions_1.batchActions)(dispatchActions));
        return this.store;
    }
    createDashboardStore(_dataPack) {
        return this.store;
    }
}
exports.ClientStoreProvider = ClientStoreProvider;
